import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./Pages/components/Home";
import About from "./Pages/components/About";
import HomeLayout from "./layouts/HomeLayout";
import Profile from "./Pages/components/Profile";
import Register from "./Pages/components/Register";
import Schedule from "./Pages/components/Schedule";
import Search from "./Pages/components/Search";
import Social from "./Pages/components/Social";
import { Provider } from "react-redux";
import PrivateRoute from "./components/PrivateRoute";
import store from "./store";
import CreatePost from "./Pages/components/CreatePost";
import BbPilots from "./Pages/components/BbPilots";
import WorkOrder from "./Pages/components/WorkOrder";
import VesselFinder from "./Pages/components/VesselFinder";
import TimeLogs from "./Pages/components/TimeLogs";
var MainApp = function () {
    return (_jsx(Provider, { store: store, children: _jsx(BrowserRouter, { children: _jsx(HomeLayout, { children: _jsx(Routes, { children: _jsx(Route, { path: "/", element: _jsx(RouteComponent, {}) }) }) }) }) }));
};
var RouteComponent = function () {
    var location = useLocation();
    var hash = location.hash;
    var ComponentToRender;
    switch (hash) {
        case "#/home": //https://chaseit1416.local/#/home
            ComponentToRender = _jsx(Home, {});
            break;
        case "#/bb-pilots":
            ComponentToRender = _jsx(BbPilots, {});
            break;
        case "#/vessel-map":
            ComponentToRender = _jsx(VesselFinder, {});
            break;
        case "#/work-order":
            ComponentToRender = _jsx(WorkOrder, {});
            break;
        case "#/about": //https://chaseit1416.local/#/about
            ComponentToRender = _jsx(About, {});
            break;
        case "#/profile": //https://chaseit1416.local/#/profile
            ComponentToRender = (_jsx(PrivateRoute, { children: _jsx(Profile, {}) }));
            break;
        case "#/register": //https://chaseit1416.local/#/register
            ComponentToRender = _jsx(Register, {});
            break;
        case "#/schedule": //https://chaseit1416.local/#/schedule
            ComponentToRender = _jsx(Schedule, {});
            break;
        case "#/search": //https://chaseit1416.local/#/search
            ComponentToRender = _jsx(Search, {});
            break;
        case "#/social": //https://chaseit1416.local/#/social
            ComponentToRender = (_jsx(PrivateRoute, { children: _jsx(Social, {}) }));
            break;
        case '#/time-logs': //https://chaseit1416.local/#/time-logs
            ComponentToRender = (_jsx(PrivateRoute, { children: _jsx(TimeLogs, {}) }));
            break;
        case "#/create-post": //https://chaseit1416.local/#/social
            ComponentToRender = (_jsx(PrivateRoute, { children: _jsx(CreatePost, {}) }));
            break;
        default: //https://chaseit1416.local
            // ComponentToRender = <App />;
            ComponentToRender = _jsx(Home, {});
    }
    return ComponentToRender;
};
ReactDOM.createRoot(document.getElementById("app")).render(_jsx(React.StrictMode, { children: _jsx(MainApp, {}) }));
